import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CardModule } from "../card/card.module";
import { CardExpandedComponent } from "./card-expanded.component";

@NgModule({
  declarations: [CardExpandedComponent],
  imports: [CommonModule, CardModule, MatDialogModule, AngularSvgIconModule],
})
export class CardExpandedModule {}
